import React, { useState, useEffect } from "react";
import image from "../../asserts/direction.png";
import ModalPopup from "../Common/Modal/Modal";
import Activate_Modal from "./Activate_Modal";
import {
  GetPartnerDataById,
  GetReqPartnerData,
  GetRequestDataById,
  PartnerStatusChange,
  statuschange,
} from "../../Api/RequestManagement/RequestManagement";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { GetRequestManagementData } from "../../Api/RequestManagement/RequestManagement";

export default function Status_Update_Modal({
  currentid,
  setIsSaveModal,
  setIsVerifyModal,
  verifyData,
  setVerifyData,
  setRequestData,
  requestData,
  comments,
  tabfilter,
  setSpinning,
  statusId
}) {
  const [isActivate, setIsActivate] = useState(false);
  const [showError, setShowError] = useState();
  const [inputValue, setInputValue] = useState();

  console.log(inputValue, "comments_Value");

  const dispatch = useDispatch();

  const closeModal = () => {
    setIsActivate(false);
  };

  const handlechange = async (valueid, valuedata) => {
    if (
      valueid == 5 ||
      (valueid == 6 && showError == true) ||
      (valueid == 4 && showError == true) ||
      inputValue?.length > 0
    ) {
      if (currentid.startsWith("tbs-op")) {
        try {
          const data = await statuschange(
            valueid,
            valuedata,
            currentid,
            inputValue,
            dispatch
          );
          console.log(
            valueid,
            valuedata,
            currentid,
            "currentidcurrentid ithu value"
          );
          toast.success(data);
          console.log(data, "check_toast_message");
          GetRequestManagementData(dispatch, tabfilter);
          // setIsVerifyModal(false);
          console.log(data);
        } catch (error) {
          console.error("Error uploading data", error);
        }
      } else {
        try {
          const data = await PartnerStatusChange(
            valueid,
            valuedata,
            currentid,
            inputValue
          );
          toast.success(data);
          GetReqPartnerData(dispatch, tabfilter);
          setIsVerifyModal(false);
          setIsSaveModal(false);
        } catch (err) {
          console.log(err);
        }
      }

      if (valueid == 6 || valueid == 4) {
        setIsSaveModal(false);
      }
    } else {
      setShowError(false);
    }
  };

  console.log(currentid, "currentidcurrentid");

  const fetchGetRequest = async () => {
    try {
      const data = await GetRequestDataById(
        verifyData,
        setVerifyData,
        setRequestData
      );
      console.log(verifyData, "data data data");
      console.log(data, "Data........");
      setRequestData(data);
      setInputValue(data?.comments);
    } catch (error) {
      console.error("Error fetching additional user data", error);
    }
  };

  const fetchPartnerData = async () => {
    console.log("i am printindhfdhfdhfhf");

    try {
      const data = await GetPartnerDataById(verifyData);
      console.log(data, "partner_data");
      setRequestData(data);
      setInputValue(data?.comments);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (verifyData != null && verifyData.startsWith("tbs-op")) {
      fetchGetRequest();
    } else if (verifyData != null && verifyData.startsWith("tbs-pat")) {
      fetchPartnerData();
    }
  }, [verifyData, setVerifyData, setRequestData]);

  return (
    <>
      {isActivate === false ? (
        <div className="flex flex-col items-center justify-center">
          <p className="text-[1.5vw] font-bold">
            {currentid.startsWith("tbs-op")
              ? "Update the Operator Status"
              : "Update the Partner Status"}
          </p>
          <img src={image} className="h-[6vw] w-[6vw] mt-[1vw]"></img>
          <div className="mt-[1vw] w-[100%] relative">
            <label className="text-[#1F487C] font-semibold text-[1.3vw]">
              Comments{" "}
              <span className="text-[.9vw] text-gray-600">{`(Optional for Approve)`}</span>{" "}
            </label>
            <input
              type="text"
              name="comments"
              placeholder="Write your comments"
              autoComplete="off"
              // value={capitalizeFirstLetter(values?.owner_name)}
              // disabled
              value={inputValue}
               onChange={(e) => {
                            const rawValue = e.target.value;
                            const cleanedValue = rawValue
                              .replace(/^\s+/, "") 
                              .replace(/\s{2,}/g, " ") 
                              .replace(/[^A-Za-z ]/g, ""); 
      
                setInputValue(cleanedValue);
              }}
              className="border-r-[0.3vw] text-[1vw] pl-[1vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.3vw] placeholder-blue border-[#1F487C] text-[#1F487C]  h-[3vw] w-[100%] rounded-[0.5vw] outline-none "
            />
            {showError === false && (
              <span className="text-[.9vw] text-red-600 absolute bottom-[-1.2vw] left-[.5vw]">
                {" "}
                Comments is required for Reject and Hold
              </span>
            )}
          </div>

          <div className="flex justify-between gap-2 mt-[1.6vw] w-full">
            <button
              className={`items-center text-[1vw] text-white shadow-md font-extrabold shadow-black space-x-[0.7vw] px-[0.8vw] w-[7vw] h-[2vw] bg-[#2A99FF] rounded-[0.5vw] ${statusId===4?"cursor-not-allowed":"cursor-pointer"}`}              onClick={() => {
                handlechange(4, "On Hold");
                // setIsSaveModal(false);
              }}
              disabled={statusId===4}
            >
              Hold
            </button>
            <button
              className={`items-center text-[1vw] text-white  shadow-md font-bold shadow-black space-x-[0.7vw] px-[0.8vw] w-[7vw] h-[2vw]  bg-[#34AE2B] rounded-[0.5vw] ${statusId===5?"cursor-not-allowed":"cursor-pointer"}`} 
              // onClick={() => setIsActivate(true)}
              onClick={() => {
                handlechange(5, "Approved");
                // setInputValue("All Documents are Good")
                if (currentid.startsWith("tbs-op")) {
                  setIsActivate(true);
                }
                //  else {
                //   setIsSaveModal(false);
                // }
              }}
              disabled={statusId===5}
            >
              Approve
            </button>
            <button
              className={`items-center text-[1vw] text-white font-extrabold shadow-md shadow-black space-x-[0.7vw] px-[0.8vw] w-[7vw] h-[2vw] bg-[#FF1100] rounded-[0.5vw] ${statusId===6?"cursor-not-allowed":"cursor-pointer"} `} 
              onClick={() => {
                handlechange(6, "Rejected");
                // setIsSaveModal(false);
              }}
              disabled={statusId===6}
            >
              Reject
            </button>
          </div>
        </div>
      ) : (
        <Activate_Modal
          isActivate={setIsActivate}
          currentid={currentid}
          setIsSaveModal={setIsSaveModal}
          verifyData={verifyData}
          setVerifyData={setVerifyData}
          setRequestData={setRequestData}
          requestData={requestData}
          setIsVerifyModal={setIsVerifyModal}
          setSpinning={setSpinning}
        />
      )}

      {/* 
<ModalPopup
        className="border border-[#1f487c] border-b-8 border-r-8 border-b-[#1f487c] border-r-[#1f487c] rounded-md"
        show={isActivate}
        closeicon={false}
        onClose={closeModal}
        height="300px"
        width="600px"
> */}
      {/* <Activate_Modal
          isActivate={setIsActivate}
          currentid={currentid}
          setIsSaveModal={setIsSaveModal}
          verifyData={verifyData}
          setVerifyData={setVerifyData}
          setRequestData={setRequestData}
          requestData={requestData}
        /> */}
      {/* </ModalPopup> */}
    </>
  );
}
